import React from 'react'
import {
  MODAL_CONFIRM_CANCEL_RESERVED_TITLE,
  MODAL_CONFIRM_CANCEL_RESERVED_CONTENT,
  MODAL_CONFIRM_CANCEL_RESERVED_OK,
} from '../../../../constants/event'
import { PrimaryConfirmModal } from '../../../molecules/ModalContainer/PrimaryDialogTemplate/PrimaryConfirmDialog'

interface ConfirmCancelModalProps {
  onSubmit: any
}

export const ConfirmCancelReservedModal: React.FC<ConfirmCancelModalProps> = props => {
  return (
    <PrimaryConfirmModal
      header={MODAL_CONFIRM_CANCEL_RESERVED_TITLE}
      content={MODAL_CONFIRM_CANCEL_RESERVED_CONTENT}
      onSubmit={props.onSubmit}
      label={MODAL_CONFIRM_CANCEL_RESERVED_OK}
      skipButton={true}
    />
  )
}
